module.exports = __webpack_public_path__ + "img/李东坡.3ae6d4f9.jpg";